import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import looppa from 'looppa';
import FlipMove from 'react-flip-move';
import CartProductListItem from './item';

const ANIMATION_OPTIONS = {
    staggerDelayBy: 50,
    delay: 300,
    duration: 300,
    maintainContainerHeight: true,
    easing: 'cubic-bezier(0.25, 0.1, 0.75, 1)',
    leaveAnimation: {
        from: {
            transform: '',
        },
        to: {
            transform: 'translate(-100%, 0)',
        },
    },
};

/* eslint-disable camelcase */
class CartProductsList extends PureComponent {
    static propTypes = {
        tabIndex: PropTypes.number.isRequired,
        products: PropTypes.object.isRequired,
        hideDraggingTutorial: PropTypes.bool.isRequired,
    };

    render() {
        const {
            products,
            tabIndex,
            hideDraggingTutorial,
        } = this.props;

        return (
            <section className="cart-products-list">
                <FlipMove
                    className="cart-products-list--collection u-reset"
                    typeName="ul"
                    { ...ANIMATION_OPTIONS }>
                    { looppa(products)((item, key, i) => (
                        <CartProductListItem tabIndex={i + tabIndex} key={item.product.id}
                            isOpened={ i === 0 && !hideDraggingTutorial && Modernizr.touchevents } item={ item }/>
                    ))}
                </FlipMove>
            </section>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        hideDraggingTutorial: 'cart.hideDraggingTutorial',
    }),
)(CartProductsList);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cart-products-list/index.js